import { render, staticRenderFns } from "./CostInfo.vue?vue&type=template&id=164a0a9e&scoped=true&"
import script from "./CostInfo.vue?vue&type=script&lang=js&"
export * from "./CostInfo.vue?vue&type=script&lang=js&"
import style0 from "./CostInfo.vue?vue&type=style&index=0&id=164a0a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164a0a9e",
  null
  
)

export default component.exports